// extracted by mini-css-extract-plugin
export default {"text":"MnuRIF","linkStyle":"POI0zU"};